import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getProfileEligibilityAlive,
  getProfileEligibilityHealthPlan,
  getProfileEligibilityNgemrPatient,
  TAG_PE_ALIVE,
  TAG_PE_HEALTHPLAN,
  TAG_PE_NGEMR_PATIENT,
} from './endpoints';

const profileEligibilityApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getProfileEligibilityHealthPlan: getProfileEligibilityHealthPlan(builder),
      getProfileEligibilityNgemrPatient: getProfileEligibilityNgemrPatient(builder),
      getProfileEligibilityAlive: getProfileEligibilityAlive(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [TAG_PE_HEALTHPLAN, TAG_PE_NGEMR_PATIENT, TAG_PE_ALIVE],
  });

export const {
  useGetProfileEligibilityHealthPlanQuery,
  useGetProfileEligibilityNgemrPatientQuery,
  useLazyGetProfileEligibilityNgemrPatientQuery,
  useGetProfileEligibilityAliveQuery,
} = profileEligibilityApi;
